import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import Marker from './Marker';

/**
* -Markers-
* Markers component
**/
export default class Markers extends React.Component {

	state = {
		markers: []
	}

	updateMarkers = () => {

		// Combine makers to array (if object)
		let markers;

		if (!Array.isArray(this.props.markers)) {

			if (_.size(this.props.markers) > 0) {

				markers = Object
					.keys(this.props.markers)
					.map((key) => this.props.markers[key]);
				markers = [].concat(...markers);
			}

		} else {

			markers = this.props.markers;
		}

		markers = (markers === undefined) ? [] : markers;

		this.setState({ markers: markers });
	}

	componentDidMount() {

		this.updateMarkers();
	}

	componentDidUpdate(prevProps) {

		const newMarkers = !_.isEqual(this.props.markers, prevProps.markers);
		if (newMarkers) {

			this.setState({ markers: [] }, () => {

				this.updateMarkers();
			});
		}
	}

	render() {

		const markers = this.state.markers.map((marker, i) =>
			<Marker
				markerlocation={ marker.location }
				title={ marker.title }
				visible={ marker.visible }
				icon={ marker.icon }
				content={ marker.content }
				label={ marker.label }
				key={ i }
				{ ...this.props }
			/>
		);

		return (
			<div>
				{ markers }
			</div>
		)
	}
}

Markers.propTypes = {
	markers: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object
	]),
}



// WEBPACK FOOTER //
// ./src/components/googlemaps/Markers.js